var _rect, _circle, _path, _path2, _rect2, _rect3, _circle2, _path3, _path4, _rect4, _rect5, _circle3, _path5, _path6, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 144,
    viewBox: "0 0 238 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 238,
    height: 143,
    rx: 8,
    fill: "#F3F5F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28.7324,
    r: 12,
    fill: "#99BED0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23.7324C22.6193 23.7324 21.5 24.8517 21.5 26.2324C21.5 27.6131 22.6193 28.7324 24 28.7324C25.3807 28.7324 26.5 27.6131 26.5 26.2324C26.5 24.8517 25.3807 23.7324 24 23.7324ZM22.5 26.2324C22.5 25.404 23.1716 24.7324 24 24.7324C24.8284 24.7324 25.5 25.404 25.5 26.2324C25.5 27.0608 24.8284 27.7324 24 27.7324C23.1716 27.7324 22.5 27.0608 22.5 26.2324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33.2324C21 31.5756 22.3431 30.2324 24 30.2324C25.6569 30.2324 27 31.5756 27 33.2324C27 33.5086 27.2239 33.7324 27.5 33.7324C27.7761 33.7324 28 33.5086 28 33.2324C28 31.0233 26.2091 29.2324 24 29.2324C21.7909 29.2324 20 31.0233 20 33.2324C20 33.5086 20.2239 33.7324 20.5 33.7324C20.7761 33.7324 21 33.5086 21 33.2324Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16.7324,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32.7324,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 72.7324,
    r: 12,
    fill: "#99BED0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 67.7324C22.6193 67.7324 21.5 68.8517 21.5 70.2324C21.5 71.6131 22.6193 72.7324 24 72.7324C25.3807 72.7324 26.5 71.6131 26.5 70.2324C26.5 68.8517 25.3807 67.7324 24 67.7324ZM22.5 70.2324C22.5 69.404 23.1716 68.7324 24 68.7324C24.8284 68.7324 25.5 69.404 25.5 70.2324C25.5 71.0608 24.8284 71.7324 24 71.7324C23.1716 71.7324 22.5 71.0608 22.5 70.2324Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77.2324C21 75.5756 22.3431 74.2324 24 74.2324C25.6569 74.2324 27 75.5756 27 77.2324C27 77.5086 27.2239 77.7324 27.5 77.7324C27.7761 77.7324 28 77.5086 28 77.2324C28 75.0233 26.2091 73.2324 24 73.2324C21.7909 73.2324 20 75.0233 20 77.2324C20 77.5086 20.2239 77.7324 20.5 77.7324C20.7761 77.7324 21 77.5086 21 77.2324Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60.7324,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76.7324,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 112.732,
    r: 12,
    fill: "#99BED0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 107.732C22.6193 107.732 21.5 108.852 21.5 110.232C21.5 111.613 22.6193 112.732 24 112.732C25.3807 112.732 26.5 111.613 26.5 110.232C26.5 108.852 25.3807 107.732 24 107.732ZM22.5 110.232C22.5 109.404 23.1716 108.732 24 108.732C24.8284 108.732 25.5 109.404 25.5 110.232C25.5 111.061 24.8284 111.732 24 111.732C23.1716 111.732 22.5 111.061 22.5 110.232Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 117.232C21 115.576 22.3431 114.232 24 114.232C25.6569 114.232 27 115.576 27 117.232C27 117.509 27.2239 117.732 27.5 117.732C27.7761 117.732 28 117.509 28 117.232C28 115.023 26.2091 113.232 24 113.232C21.7909 113.232 20 115.023 20 117.232C20 117.509 20.2239 117.732 20.5 117.732C20.7761 117.732 21 117.509 21 117.232Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100.732,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 116.732,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#005C89",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/activeUsers.d8089c1de9563780dd541623222a2369.svg";
export { ForwardRef as ReactComponent };